import { HttpInterceptorFn } from '@angular/common/http';

import { authDeviceInterceptor } from './auth-device.interceptor';
import { authTokenInterceptor } from './auth-token.interceptor';
import { loaderHttpErrorInterceptor } from './loader-error.interceptor';

export const HTTP_INTERCEPTORS: HttpInterceptorFn[] = [
  authTokenInterceptor,
  authDeviceInterceptor,
  loaderHttpErrorInterceptor,
];
